import { LOGIN, LOGIN_ERROR } from '../home/HomeConstants'

export const loginPageReducerBlackList = [LOGIN, LOGIN_ERROR]
